import { axios, getAxiosConfig } from '@config/axios';
import Environment from '@config/index';
import { Negotiation } from '@interfaces/models/negotiation';
import { NegotiationEventRequest } from '@interfaces/models/negotiationEventRequest';
import { ApiResponse } from '@interfaces/api';
import { UserTransactionRole } from '@interfaces/models/userTransactionRole';

export default class NegotiationsService {
  static apiBaseUrl = Environment.apiBaseUrl;

  static async listNegotiations(role: UserTransactionRole, withEvents: boolean): Promise<ApiResponse<Negotiation[]>> {
    const axiosConfig = getAxiosConfig();
    axiosConfig.params = {
      ...axiosConfig.params,
      ...(!!role && {
        role,
      }),
      ...(!!withEvents && {
        withEvents,
      }),
    };

    const { data } = await axios.get<ApiResponse<Negotiation[]>>(`${this.apiBaseUrl}/negotiations`, axiosConfig);
    return data;
  }

  static async getNegotiation(id: Negotiation['id']): Promise<Negotiation | undefined> {
    const axiosConfig = getAxiosConfig();

    const {
      data: { data },
    } = await axios.get<ApiResponse<Negotiation | undefined>>(`${this.apiBaseUrl}/negotiations/${id}`, axiosConfig);

    return data || undefined;
  }

  static async addNegotiationEvent(
    id: Negotiation['id'],
    payload: NegotiationEventRequest,
  ): Promise<ApiResponse<Negotiation>> {
    const axiosConfig = getAxiosConfig();

    const { data } = await axios.post<ApiResponse<Negotiation>>(
      `${this.apiBaseUrl}/negotiations/${encodeURIComponent(String(id))}/events`,
      payload,
      axiosConfig,
    );
    return data;
  }

  static async executeFPD(
    id: Negotiation['id'],
    payload: NegotiationEventRequest | {},
  ): Promise<ApiResponse<Negotiation>> {
    const axiosConfig = getAxiosConfig();

    const { data } = await axios.post<ApiResponse<Negotiation>>(
      `${this.apiBaseUrl}/negotiations/${encodeURIComponent(String(id))}/flash-price-drop`,
      payload,
      axiosConfig,
    );
    return data;
  }
}
